<template>
	<div class="component">
		<van-popup v-model="show" round position="bottom" :style="{ height: '50%' }">
			<van-datetime-picker
				v-model="currentDate"
				type="date"
				:title="showTime"
				:min-date="minDate"
				@cancel="onCancel"
				@confirm="choseDate"
				v-if="qh"
			/>
		</van-popup>
	</div>
</template>

<script>
export default {
	data() {
		return {
			show: false,
			currentDate: new Date(),
			date: new Date(),
			index: "",
			// showtime
			showTime: '自定义上线时间',
			minute: null,
			hour: null,
			begin: '',
			minDate: new Date(2000, 0, 1),
			qh: true,
		}
	},
	created() {
	},
	watch: {},
	methods: {
		$show(i, e) {
			this.show = true
			this.index = i
			this.name = e
			this.showTime = '开始时间'
		},
		onCancel() {
			this.qh = false
			this.$nextTick(() => {
				this.qh = true
				this.begin = ''
				this.index = ''
				this.currentDate = new Date()
				this.minDate = new Date(2000, 0, 1)
				this.show = false
				this.$emit('change', null)
			})

		},
		choseDate(e) {
			if (this.begin === '') {
				this.minDate = new Date(e.getFullYear(), e.getMonth(), e.getDate())
				this.begin = e.getFullYear() + "-" + (e.getMonth() + 1) + "-" + e.getDate()
				this.showTime = "结束时间"
			} else {
				const dateTime = {
					time: this.begin + "|" + e.getFullYear() + "-" + (e.getMonth() + 1) + "-" + e.getDate(),
					index: this.index,
					name: this.name
				}
				this.begin = ''
				this.show = false
				this.$emit('change', dateTime)
			}
		}
	}
}
</script>

<style lang="less" scoped>
/deep/ .van-action-sheet__header {
	font-weight: bolder;
}

.component {
}
</style>
